import { Div, Span } from "@tblabs/truffle";
import { ExpirationTimer } from "../Utils/ExpirationTimer";
import { MarkedStep } from "../Models/MarkedStep";


export class CustomerStepPrinter extends Div
{
    // private timer = new ExpirationTimer(this.step.Step.Timeout);

    constructor(private step: MarkedStep)
    {
        super("step-box customer-view");

        this.Refresh();
    }

    // public async OnRemove()
    // {
    //     this.timer.Dispose();
    // }

    private Refresh()
    {
        const step = this.step.Step;

        this.Clear()
            .Append(
                new Div("step-content").TextAlignCenter()
                    .Append(
                        new Div("step-title").Append(
                            new Span(step.GetTitleForCustomer()).Attribute("data-test-class", "step-title-text")
                        ),
                        new Div("step-description").Append(
                            ...step.GetCustomerContent()
                        )
                    ),
                // new Div("step-footer").Append(
                //     this.step.IsCurrent && this.timer.HasTimeout && new Text(this.timer.ExpiresIn).Class("step-timeout")
                // )
            );
    }
}
